import React, { FC, ReactNode } from 'react';
import _ from 'lodash';
import { TemplateGalleryCard } from '@common/types';
import TemplateCardAdaptive from '@components/Templates/TemplateGallery/TemplateCard/TemplateCardAdaptive';
import s from './FeaturedTemplatesMobile.module.scss';

type Props = {
  templates: TemplateGalleryCard[];
  getActionButton?: (template: TemplateGalleryCard) => ReactNode;
  getCardOnClick?: (template: TemplateGalleryCard) => (() => void) | undefined;
  entryParam?: string;
};

const FeaturedTemplatesMobile: FC<Props> = ({
  templates,
  getActionButton,
  getCardOnClick,
  entryParam,
}) => {
  return (
    <div className={s.templatesMobile}>
      {_.map(templates, (template, index) => (
        <TemplateCardAdaptive
          key={template.id}
          isMobileView={true}
          template={template}
          index={index}
          actionButton={getActionButton?.(template)}
          actionButtonVisibility="always"
          onCustomClick={getCardOnClick?.(template)}
          entryParam={entryParam}
        />
      ))}
    </div>
  );
};

export default FeaturedTemplatesMobile;
